// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__32L9f","header":"ReportDetails_header__E_9KU","title":"ReportDetails_title__38e2j","left":"ReportDetails_left__2V7c4"};